import React, { useRef } from 'react'
import { useGSAP } from '@gsap/react';
import customTransition from '../utils/transition';
import Header from '../components/Header';



function StartupWeekend() {
    const container = useRef();

    useGSAP(
        () => {
        },
        { scope: container }
    );

    const submitForm = async (e) => {
        e.preventDefault();
        const data = new FormData(e.target);

        const lead = {
            name: data.get("name")?.toString().trim(),
            phone: data.get("phone")?.toString().trim(),
            telegram: data.get("telegram")?.toString().trim(),
            company: data.get("company")?.toString().trim(),
            collaboration: data.get("collaboration")?.toString().trim(),
            submittedAt: new Date().toLocaleString("ru-RU", { timeZone: "Asia/Tashkent" }),
        };

        const botToken = process.env.REACT_APP_TG_BOT_TOKEN;
        const chatIds = (process.env.REACT_APP_TG_CHAT_IDS || "")
            .split(",")
            .map((id) => id.trim())
            .filter(Boolean);

        console.log(chatIds, botToken, lead);

        if (!botToken || chatIds.length === 0) {
            console.error("Missing REACT_APP_TG_BOT_TOKEN or REACT_APP_TG_CHAT_IDS");
            alert("Configuration error. Please contact admin.");
            return;
        }

        const text = [
            "🔥 New Lead (Hackonnect Landing)",
            "",
            `👤 Name: ${lead.name}`,
            `📱 Phone: ${lead.phone}`,
            `💬 Telegram: ${lead.telegram}`,
            `🏢 Company: ${lead.company}`,
            `🤝 Where we can collaborate?: ${lead.collaboration}`,
            "",
            `⏱️ Time: ${lead.submittedAt}`,
        ].join("\n");

        try {
            await Promise.all(
                chatIds.map((chat_id) =>
                    fetch(`https://api.telegram.org/bot${botToken}/sendMessage`, {
                        method: "POST",
                        headers: { "Content-Type": "application/json" },
                        body: JSON.stringify({
                            chat_id: chat_id.includes(":") ? chat_id.split(":")[0] : chat_id,
                            message_thread_id: chat_id.includes(":") ? parseInt(chat_id.split(":")[1], 10) : undefined,
                            text,
                        }),
                    }).then(async (res) => {
                        if (!res.ok) {
                            const err = await res.text();
                            throw new Error(`Telegram send failed (${chat_id}): ${err}`);
                        }
                    })
                )
            );
            alert("Submitted successfully! We'll get back to you soon.");
            e.target.reset();
        } catch (err) {
            console.error(err);
            alert("Failed to submit. Please try again.");
        }
    };

    return (
        <div>
            <main ref={container}>
                <div className='container'>
                    <div className='contact-wrapper'>
                        <div className='contact-block'>
                            <h1>Let's start a project</h1>
                            <form onSubmit={submitForm}>
                                <input name="name" placeholder='Full Name' required />
                                <input name="phone" type="tel" placeholder='Phone number' required />
                                <input name="telegram" type="text" placeholder='Telegram username' required />
                                <input name="company" type="text" placeholder='Company' required />
                                <label>Where we can collaborate?</label>
                                <textarea
                                    name="collaboration"
                                    placeholder='Your answer'
                                    rows="1"
                                    required
                                    onInput={(e) => {
                                        e.target.style.height = "auto";
                                        e.target.style.height = `${e.target.scrollHeight}px`;
                                    }}
                                />
                                <br />
                                <button type="submit" className='btn'>Submit</button>
                            </form>
                        </div>
                    </div>
                </div>
            </main>
        </div>
    )
}

export default customTransition(StartupWeekend);